module.exports = __webpack_public_path__ + "static/media/dragon_bowl.bbaaa31c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image/dragon_bowl.jpg
// module id = 156
// module chunks = 0